import { showToast } from '@tix-ticketing/ui-components';

export const toastError = (
  errorResponse:
    | { title?: string | null; status?: number | null; detail?: string | null }
    | undefined
    | null
) => {
  showToast({
    title: errorResponse?.title || 'Error',
    message: errorResponse?.detail || 'An unexpected error occurred',
    severity: 'error',
  });
};

/**
 * Same as `toastError`, but for a rejected request rather than a response body:
 * digs the ProblemDetails payload out of the Axios error before toasting it.
 */
export const toastRequestError = (error: unknown) =>
  toastError(
    (error as { response?: { data?: Parameters<typeof toastError>[0] } })
      ?.response?.data
  );

/**
 * Same as `toastRequestError`, but for a request made with `responseType: 'blob'`
 * — Axios applies that response type to error responses too, so the
 * ProblemDetails payload arrives as a Blob and has to be read back out of it
 * before the backend's own message can be shown.
 */
export const toastBlobRequestError = async (error: unknown) => {
  const data = (error as { response?: { data?: unknown } })?.response?.data;

  if (!(data instanceof Blob)) {
    toastRequestError(error);
    return;
  }

  try {
    toastError(JSON.parse(await data.text()));
  } catch {
    // An empty or non-JSON body (a bare 403, say) leaves nothing to quote.
    toastError(undefined);
  }
};

export const unexpectedErrorToast = () => {
  showToast({
    title: 'Unexpected Error',
    message: 'An unexpected error occurred',
    severity: 'error',
  });
};
